var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bim-datepick',{attrs:{"value":_vm.value,"type":"datetime","format":_vm.format,"placeholder":_vm.placeholder,"range":_vm.range,"formKey":"value","formModel":_vm._self},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }